module.exports = __webpack_public_path__ + "img/theme5.6cda121e.png";